import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface IStoreState {
  storeSeq: string; // 암호화된 번호
  storeSeqNumber: number; // 숫자번호 (임시)
  storeName: string;
}
export interface IStore extends IStoreState {
  setStoreInfo: (data: IStoreState) => void;
}

const useStoreStore = create<IStore>()(
  persist(
    (set, get) => ({
      storeSeq: '',
      storeName: '',
      storeSeqNumber: 0,
      setStoreInfo: (data: IStoreState) =>
        set((state) => ({
          storeSeq: data?.storeSeq ?? '',
          storeName: data.storeName,
          storeSeqNumber: data.storeSeqNumber,
        })),
    }),
    {
      name: 'store-storage',
      onRehydrateStorage: (state) => {
        // console.log('hydration starts', state);

        return (state, error) => {
          if (error) {
            console.log('an error happened during hydration', error);
          } else {
            // console.log('hydration finished', state);
          }
        };
      },
    },
  ),
);

export default useStoreStore;
